import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// content type
apiClient.defaults.headers.post["Content-Type"] = "application/json";

apiClient.interceptors.request.use( config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// intercepting to capture errors
apiClient.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    return [];
  }
);

class ApiCore {
  /**
   * Fetches data from given url
   */
  get = (url: string, params?: {}) => {
    return axios.get(url, params);
  };

  /**
   * post given data to url
   */
  create = (url: string, data: {}) => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url: string, data: {}) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url: string, data?: {}) => {
    return axios.delete(url, { ...data });
  };
}


export { apiClient, ApiCore };
